{
  "MMM Do YYYY, h:mm a": "D [de] MMM [de] YYYY, HH:mm",
  "MMM Do YYYY": "D [de] MMM [de] YYYY",
  "Wedding": "Casamento",
  "Funeral": "Funeral",
  "Birthday": "Aniversário",
  "School": "Escola",
  "Sport": "Esporte",
  "event type|Other": "Outro",
  "Audio/video professional": "Profissional de áudio e vídeo",
  "Funeral home owner or director": "Responsável por funerária",
  "Event planner or venue manager": "Profissional de eventos ou responsável por espaço de eventos",
  "Church, pastor, preacher or minister": "Igreja, pastor, pregador ou ministro",
  "Teacher or school manager": "Docente ou responsável por escola",
  "Nonprofit or charity": "Organização sem fins lucrativos ou beneficente",
  "Live event streamer or producer": "Profissional de transmissão ou produção de eventos ao vivo",
  "role|Other": "Outro",
  "room noun|room": "sala",
  "room noun|stage": "palco",
  "room noun|track": "pista",
  "room noun|court": "quadra",
  "room noun|field": "campo",
  "room noun|hall": "pavilhão",
  "room noun|camera": "câmera",
  "Sorry, we need camera roll permissions to make this work!": "Desculpe, precisamos de acesso às suas fotos para que isso funcione.",
  "Streaming Permissions Required": "Permissões necessárias para transmitir",
  "EventLive cannot open streaming until camera, microphone, and recording permissions are enabled.": "O EventLive só consegue abrir a transmissão depois que as permissões de câmera, microfone e gravação forem ativadas.",
  "Search for an event": "Pesquisar um evento",
  "Schedule your first service": "Agende sua primeira cerimônia",
  "Create your first event": "Crie seu primeiro evento",
  "Each service gets a private link to share with the family. Families watch on any device, with no app or login.": "Cada cerimônia tem um link privado para compartilhar com a família. As famílias assistem em qualquer dispositivo, sem app e sem cadastro.",
  "It looks like you have no events at the moment. Create one to see it here": "Parece que você ainda não tem eventos. Crie um para vê-lo aqui",
  "Schedule a Service": "Agendar uma cerimônia",
  "Create an Event": "Criar um evento",
  "You have {count} event credit. Each service day uses one.": {
    "one": "Você tem {count} crédito de evento. Cada dia de cerimônia usa um.",
    "other": "Você tem {count} créditos de evento. Cada dia de cerimônia usa um."
  },
  "You have {count} event credit. Each event day uses one.": {
    "one": "Você tem {count} crédito de evento. Cada dia de evento usa um.",
    "other": "Você tem {count} créditos de evento. Cada dia de evento usa um."
  },
  "You have {count} prepaid event – it will be used for this event.": {
    "one": "Você tem {count} evento pré-pago, que será usado para este evento.",
    "other": "Você tem {count} eventos pré-pagos. Um deles será usado para este evento."
  },
  "Leave": "Sair",
  "Keep editing": "Continuar editando",
  "Leave without scheduling the service?": "Sair sem agendar a cerimônia?",
  "Leave without scheduling the event?": "Sair sem agendar o evento?",
  "Schedule your live fundraiser": "Agende sua arrecadação ao vivo",
  "Schedule a service": "Agende uma cerimônia",
  "Schedule your first event": "Agende seu primeiro evento",
  "Schedule your event": "Agende seu evento",
  "Next, you'll confirm {organization} as the organization receiving donations. You can change the details later.": "Em seguida, você vai confirmar {organization} como a organização que receberá as doações. Você pode alterar os detalhes depois.",
  "Next, you'll choose the organization receiving donations. You can change the details later.": "Em seguida, você vai escolher a organização que receberá as doações. Você pode alterar os detalhes depois.",
  "The family gets one private link to watch live or later. You can change the details any time.": "A família recebe um link privado para assistir ao vivo ou depois. Você pode alterar os detalhes quando quiser.",
  "You can change the details later.": "Você pode alterar os detalhes depois.",
  "Are you sure you want to delete {title} and its {count} stage?": {
    "one": "Tem certeza de que quer excluir {title} e o palco?",
    "other": "Tem certeza de que quer excluir {title} e os {count} palcos?"
  },
  "Are you sure you want to delete {title} and its {count} track?": {
    "one": "Tem certeza de que quer excluir {title} e a pista?",
    "other": "Tem certeza de que quer excluir {title} e as {count} pistas?"
  },
  "Are you sure you want to delete {title} and its {count} court?": {
    "one": "Tem certeza de que quer excluir {title} e a quadra?",
    "other": "Tem certeza de que quer excluir {title} e as {count} quadras?"
  },
  "Are you sure you want to delete {title} and its {count} field?": {
    "one": "Tem certeza de que quer excluir {title} e o campo?",
    "other": "Tem certeza de que quer excluir {title} e os {count} campos?"
  },
  "Are you sure you want to delete {title} and its {count} hall?": {
    "one": "Tem certeza de que quer excluir {title} e o pavilhão?",
    "other": "Tem certeza de que quer excluir {title} e os {count} pavilhões?"
  },
  "Are you sure you want to delete {title} and its {count} camera?": {
    "one": "Tem certeza de que quer excluir {title} e a câmera?",
    "other": "Tem certeza de que quer excluir {title} e as {count} câmeras?"
  },
  "Are you sure you want to delete {title} and its {count} room?": {
    "one": "Tem certeza de que quer excluir {title} e a sala?",
    "other": "Tem certeza de que quer excluir {title} e as {count} salas?"
  },
  "Could not delete event": "Não foi possível excluir o evento",
  "Are you sure you want to delete {title}?": "Tem certeza de que quer excluir {title}?",
  "This action cannot be undone.": "Esta ação não pode ser desfeita.",
  "Delete Event": "Excluir evento",
  "Deleting Event...": "Excluindo evento...",
  "Delete {camera}": "Excluir {camera}",
  "How to Go Live": "Como transmitir ao vivo",
  "Guest List & Invite": "Lista de convidados e convites",
  "Title, Date, Time, Event Link, Uploads": "Título, data, hora, link do evento e arquivos",
  "Add Another Camera Angle": "Adicionar outro ângulo de câmera",
  "Add a Room, Stage or Track": "Adicionar sala, palco ou pista",
  "Chat": "Chat",
  "Privacy Settings": "Configurações de privacidade",
  "Event Branding": "Marca do evento",
  "Event Analytics": "Estatísticas do evento",
  "Expiring soon": "Expira em breve",
  "Storage expiry": "Expiração do armazenamento",
  "You're invited to watch {title}": "Convidamos você para assistir a {title}",
  "Guests use your main link and switch to this camera there. Stream it from its own phone.": "Os convidados usam o seu link principal e mudam para esta câmera por lá. Use um celular só para ela.",
  "Share this link: guests switch between the cameras while they watch. Each camera streams from its own phone.": "Compartilhe este link: os convidados alternam entre as câmeras enquanto assistem. Cada câmera transmite do próprio celular.",
  "Guests use the main link and switch {noun}s on the event page. This {noun} streams with its own key.": "Os convidados usam o link principal e trocam de {noun} na página do evento. Esta transmissão tem chave própria.",
  "Share this link: guests switch {noun}s on the event page. Each {noun} streams with its own key.": "Compartilhe este link: os convidados trocam de {noun} na página do evento. Cada {noun} transmite com a própria chave.",
  "Your event link:": "Link do seu evento:",
  "{days}-day event:  Unlock with {count} more credit": {
    "one": "Evento de {days} dias: desbloquear com mais {count} crédito",
    "other": "Evento de {days} dias: desbloquear com mais {count} créditos"
  },
  "Unlock with {count} credit": {
    "one": "Desbloquear com {count} crédito",
    "other": "Desbloquear com {count} créditos"
  },
  "{days}-day event: Unlock with {count} prepaid events": "Evento de {days} dias: desbloquear com {count} eventos pré-pagos",
  "{days}-day event: Unlock with your prepaid event": "Evento de {days} dias: desbloquear com seu evento pré-pago",
  "Unlock with {count} prepaid events": "Desbloquear com {count} eventos pré-pagos",
  "Unlock with your prepaid event": "Desbloquear com seu evento pré-pago",
  "Your private event link is scheduled to expire on {date}. Keep your event page, the video and the guestbook online for 1 more year, or for 10 years.": "O link privado do seu evento vai expirar em {date}. Mantenha a página do evento, o vídeo e o livro de visitas disponíveis por mais 1 ano ou por 10 anos.",
  "Keep My Memories Online Longer": "Manter minhas lembranças disponíveis por mais tempo",
  "Download & View Stats": "Baixar e ver estatísticas",
  "This Event is in the Secure Archive.": "Este evento está no Arquivo Seguro.",
  "The public streaming period for this event has ended. The streaming link has expired, but the memories are safe in our archive.": "O período de transmissão pública deste evento terminou. O link de transmissão expirou, mas as lembranças estão guardadas com segurança no nosso arquivo.",
  "Restore this Event": "Restaurar este evento",
  "Unlock cameras": "Desbloquear câmeras",
  "{days}-Day Event: {start} – {end}": "Evento de {days} dias: {start} – {end}",
  "Expires in {count} day": {
    "one": "Expira em {count} dia",
    "other": "Expira em {count} dias"
  },
  "Event is in the Secure Archive": "O evento está no Arquivo Seguro",
  "Extend": "Prorrogar",
  "Use credit": "Usar crédito",
  "Use prepaid event": "Usar evento pré-pago",
  "Could not unlock the event": "Não foi possível desbloquear o evento",
  "Pay As You Go": "Pagamento por uso",
  "Couldn't schedule the service": "Não foi possível agendar a cerimônia",
  "Couldn't schedule the event": "Não foi possível agendar o evento",
  "Service title": "Título da cerimônia",
  "e.g. Celebration of Life for Jane Doe": "Ex.: Homenagem a Maria Silva",
  "e.g. Anna & Mark's wedding": "Ex.: Casamento de Ana e Marcos",
  "your-event-link": "seu-evento",
  "Available": "Disponível",
  "Event type": "Tipo de evento",
  "Choose the type of event": "Escolha o tipo de evento",
  "When the service starts": "Quando a cerimônia começa",
  "When the event starts": "Quando o evento começa",
  "Make it a multi-day event": "Transformar em evento de vários dias",
  "Raise donations for a nonprofit": "Arrecadar doações para uma organização sem fins lucrativos",
  "Viewers can donate on your event page. You'll choose the organization after the event is created.": "Os espectadores podem doar na página do seu evento. Você escolherá a organização depois de criar o evento.",
  "Schedule service": "Agendar cerimônia",
  "Schedule event": "Agendar evento",
  "Event details": "Detalhes do evento",
  "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.": "{room} segue a data, a hora e os dias do evento principal. Altere-os lá, e cada {noun} acompanha a mudança.",
  "Changes here apply to all {noun}s. Extra days are charged per {noun}.": "As alterações feitas aqui valem para cada {noun}. Os dias extras são cobrados por {noun}.",
  "Title and location": "Título e local",
  "Test events keep their name.": "Os eventos de teste mantêm o nome.",
  "e.g. St. Mary's Church, Austin": "Ex.: Paróquia Santa Maria, Curitiba",
  "Links and files": "Links e arquivos",
  "Shown under the video on your event page: a registry, a donation page, a website or a program.": "Aparecem abaixo do vídeo na página do seu evento: uma lista de presentes, uma página de doações, um site ou a programação.",
  "Event rescheduled": "Evento reagendado",
  "Guests will see the new date.": "Os convidados verão a nova data.",
  "Couldn't change the date": "Não foi possível alterar a data",
  "Event date and time": "Data e hora do evento",
  "Choose the event's local date and time": "Escolha a data e a hora locais do evento",
  "Save date and time": "Salvar data e hora",
  "Change Link": "Alterar link",
  "Change event link?": "Alterar o link do evento?",
  "If you've already shared the current link with guests, they won't be able to access the event with the old link anymore. Are you sure you want to proceed?": "Se você já compartilhou o link atual com os convidados, eles não vão mais conseguir acessar o evento pelo link antigo. Tem certeza de que quer continuar?",
  "Event link changed": "Link do evento alterado",
  "Couldn't change the link": "Não foi possível alterar o link",
  "Share this link with your guests.": "Compartilhe este link com seus convidados.",
  "your-event-name": "nome-do-seu-evento",
  "Copy event link": "Copiar link do evento",
  "Guests who already have the old link won't be able to open the event with it.": "Os convidados que já têm o link antigo não vão conseguir abrir o evento com ele.",
  "Change link": "Alterar link",
  "Edit {title}": "Editar {title}",
  "Edit link": "Editar link",
  "Add a name": "Adicione um nome",
  "Add a web address": "Adicione um endereço web",
  "Open {title}": "Abrir {title}",
  "Open link": "Abrir link",
  "Remove {title}": "Remover {title}",
  "Remove link": "Remover link",
  "File name guests see": "Nome do arquivo que os convidados veem",
  "Link text": "Texto do link",
  "e.g. Order of service": "Ex.: Programação da cerimônia",
  "e.g. Our registry": "Ex.: Nossa lista de presentes",
  "Web address": "Endereço web",
  "Add link": "Adicionar link",
  "File added": "Arquivo adicionado",
  "Guests can open it from the event page.": "Os convidados podem abri-lo na página do evento.",
  "Removed \"{title}\"": "Você removeu “{title}”",
  "Removed \"link\"": "Você removeu o link",
  "Tap to undo": "Toque para desfazer",
  "Uploading…": "Enviando…",
  "Upload file": "Enviar arquivo",
  "file type|Text": "Texto",
  "file type|Image": "Imagem",
  "file type|File": "Arquivo",
  "Document": "Documento",
  "Add the text guests will see.": "Adicione o texto que os convidados verão.",
  "Add the web address.": "Adicione o endereço web.",
  "Enter an address like zola.com/registry or an email.": "Digite um endereço como zola.com/registry ou um e-mail.",
  "Multi-Day event?": "Evento de vários dias?",
  "Days": "Dias",
  "Timezone: {timezone}": "Fuso horário: {timezone}",
  "Search timezone...": "Pesquisar fuso horário...",
  "Select timezone": "Selecione o fuso horário",
  "MMMM D, yyyy h:mm a": "D [de] MMMM [de] YYYY, HH:mm",
  "dddd, MMMM D, YYYY": "dddd, D [de] MMMM [de] YYYY",
  "ddd, MMM D": "ddd, D [de] MMM",
  "Start Time": "Hora de início",
  "Event Date and Local Time": "Data e hora local do evento",
  "Event Date": "Data do evento",
  "Select": "Selecionar",
  "date picker|Choose": "Escolher",
  "date picker|Not available": "Indisponível",
  "date picker|Month": "Mês",
  "date picker|Previous Month": "Mês anterior",
  "date picker|Next Month": "Próximo mês",
  "EEEE, MMMM d, yyyy": "EEEE, d 'de' MMMM 'de' yyyy",
  "Start time": "Hora de início",
  "h:mm aa": "HH:mm",
  "date picker|time": "hora",
  "MMMM d, yyyy h:mm aa": "d 'de' MMMM 'de' yyyy HH:mm",
  "EEE, MMM d": "EEE, d 'de' MMM",
  "Hide the event page? Guests won't be able to open it.": "Ocultar a página do evento? Os convidados não vão conseguir abri-la.",
  "Hide the event page?": "Ocultar a página do evento?",
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.": {
    "one": "Quem comprou ingresso não poderá assistir à transmissão ao vivo nem à gravação até você mostrar a página de novo. {count} pessoa da sua lista de convidados perderá o acesso.",
    "other": "Quem comprou ingresso não poderá assistir à transmissão ao vivo nem à gravação até você mostrar a página de novo. {count} pessoas da sua lista de convidados perderão o acesso."
  },
  "People who bought tickets won't be able to watch the live stream or the replay until you show the page again.": "Quem comprou ingresso não poderá assistir à transmissão ao vivo nem à gravação até você mostrar a página de novo.",
  "{days}-Day Event: {start}": "Evento de {days} dias: {start}",
  "This event isn't unlocked yet. Ask an admin of {team}'s account to unlock it.": "Este evento ainda não foi desbloqueado. Peça a um administrador da conta de {team} para desbloqueá-lo.",
  "Couldn't load {team}'s events. Try again.": "Não foi possível carregar os eventos de {team}. Tente novamente.",
  "Switch to my account": "Mudar para minha conta",
  "No events yet": "Nenhum evento ainda",
  "Events in {team}'s account will show up here.": "Os eventos da conta de {team} aparecerão aqui.",
  "Event unlocked": "Evento desbloqueado",
  "Couldn't unlock this event": "Não foi possível desbloquear este evento",
  "{team}'s account may not have enough credits. Ask the account holder to add more.": "Talvez a conta de {team} não tenha créditos suficientes. Peça ao titular da conta para adicionar mais."
}
